import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import duration from "dayjs/plugin/duration";

const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
require("dayjs/locale/pt");

dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.locale("pt");

export function formatDate(
  value,
  formatString = "DD/MM/YYYY HH:mm:ss",
  originFormat = "YYYY-MM-DD HH:mm:ss"
) {
  if (!value) return "";

  const date = dayjs(value, originFormat);

  if (!date.isValid()) {
    return "Invalid Date";
  }

  return date.format(formatString);
}

export function currentDate(formatString = "DD/MM/YYYY HH:mm:ss") {
  const date = new Date();
  return dayjs(date).format(formatString);
}

export function formatTimezoneDate(
  value,
  formatString = "DD/MM/YYYY HH:mm:ss",
  originFormat = null,
  timezone = "America/Sao_Paulo"
) {
  if (!value) return "";

  const date = originFormat
    ? dayjs(value, originFormat).utc()
    : dayjs(value).utc();

  return date.tz(timezone).format(formatString);
}

export function isValidDate(
  dateStr,
  checkAgeRestriction = false,
  formatString = "DD/MM/YYYY"
) {
  const date = dayjs(dateStr, formatString, true);

  if (!date.isValid()) return false;

  const currentYear = dayjs().year();
  const dateYear = date.year();

  if (dateYear > currentYear) return false;

  if (checkAgeRestriction) {
    const today = dayjs();
    const age = today.diff(date, "year");

    if (age < 18) return false;
  }

  return true;
}

export function calculateTimeRemaining(endDate) {
  const now = dayjs();
  const target = dayjs(endDate);
  const diff = target.diff(now);

  if (diff <= 0) {
    return "00:00:00";
  } else {
    const duration = dayjs.duration(diff);

    const hours = String(duration.hours()).padStart(2, "0");
    const minutes = String(duration.minutes()).padStart(2, "0");
    const seconds = String(duration.seconds()).padStart(2, "0");

    return `${hours}:${minutes}:${seconds}`;
  }
}
